export const backend_server_address = process.env.REACT_APP_BACKEND_BASE_URL;
